var CompanyService = (function () {
    function CompanyService($http) {
        this.$http = $http;
        this.WsUrl = ResolveUrl("~/LoanData.asmx");
    }
    CompanyService.prototype.getAll = function () {
        return this.$http.post(this.WsUrl + "/GetAllCompany", {});
    };
    CompanyService.$inject = ["$http"];
    return CompanyService;
}());
angular
    .module("London.Services")
    .service("CompanyService", CompanyService);
